import { bb } from "$json";
import { conf } from "$json/lib/conf";
import { path } from "$json/lib/functional";
/* inspector:
 *
 * Add a Data Inspector
 *
 * Author: Niels Giesen
 * Copyright 2011 Berkeley Bridge
 *
 */
(function ($) {
  if (path(["arbitrary", "inspector", "xslt-only"], conf)) return;
  $(function () {
    var inspectbutton = $(
      '<input type="button" value="inspect" style="position:fixed;left:0;top:0"/>'
    );

    $("body").append(inspectbutton);
    bb.Mode.set("debug");

    inspectbutton.on("click", function () {
      inspectData();
      $(document).on("bb:postHandleData", function (event, data, status, req) {
        if (
          typeof data != "undefined" &&
          data.groups &&
          data.groups.length > 0
        ) {
          inspectData();
        }
      });
    });

    function getServer() {
      return location.href.replace(/\/[^/]*$/, "");
    }

    function inspectData() {
      window.open(
        getServer() +
          "/report?dbname=" +
          bb.getVar("dbname") +
          "&sessionid=" +
          bb.getVar("sessionid") +
          "&uniqueid=" +
          bb.getVar("uniqueid") +
          "&template=inspector",
        "DataInspector"
      );
    }

    function toggleInspectbutton() {
      inspectbutton.toggle(bb.Mode.get("hasModel"));
    }

    toggleInspectbutton();

    $(document).on("bb:postHandleData", toggleInspectbutton);
  });
})(jQuery);
